module.exports = __webpack_public_path__ + "static/media/homeBroker.357af1e9.svg";